import { serviceOrdersApi, type ListServiceOrdersQuery } from '@/api/service-orders';
import type { ServiceOrderSummaryDto } from '@bhops/shared';

// 서비스 오더를 쪽(page)을 넘겨 가며 모두 받는다. 서버는 한 번에 100건까지만 준다
// (ListServiceOrdersQueryDto pageSize @Max(100)).
//
// 2026-10-19 — 통합 캘린더 · 다가오는 일정이 예방정비(PREVENTIVE)를 pageSize 200 으로 한 번에
// 부르다 서버가 400 으로 거절해, 캘린더에 유지보수가 **한 건도** 안 보였다(오너: "유지보수 일정 두 번
// 추가했는데 둘 다 캘린더에 안 보이네"). 이 함수로 100건씩 끝까지 받는다.

const PAGE_SIZE = 100;
/** 안전 한도 — 100 × 30 = 3,000건. 넘으면 그만 받는다(캘린더 용도엔 충분). */
const MAX_PAGES = 30;

export async function listAllServiceOrders(
  query: Omit<ListServiceOrdersQuery, 'page' | 'pageSize'> = {},
): Promise<{ items: ServiceOrderSummaryDto[]; total: number }> {
  const items: ServiceOrderSummaryDto[] = [];
  let total = 0;
  for (let page = 1; page <= MAX_PAGES; page++) {
    const res = await serviceOrdersApi.list({ ...query, page, pageSize: PAGE_SIZE });
    items.push(...res.items);
    total = res.total;
    if (res.items.length < PAGE_SIZE || items.length >= total) break;
  }
  return { items, total };
}
